const DAY_MS = 24 * 60 * 60 * 1000;
const toNum = value => (Number.isFinite(Number(value)) ? Number(value) : 0);

const pad = n => String(n).padStart(2, '0');
const toISODate = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export function defaultStatsRange(today = new Date(), days = 30) {
  return { desde: toISODate(new Date(today.getTime() - days * DAY_MS)), hasta: toISODate(today) };
}

export function efectividad(entregadas, totalGuias) {
  const total = toNum(totalGuias);
  return total > 0 ? (toNum(entregadas) / total) * 100 : 0;
}

export function formatPercent(value) {
  return `${toNum(value).toLocaleString('es-AR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %`;
}

export function formatCurrency(value) {
  return `$ ${toNum(value).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Reprogramadas still have to be delivered, so they count as pending next to the unattended ones. */
export function pendientesDe(row) {
  return toNum(row?.pendientes) + toNum(row?.reprogramadas);
}

export function summarizeRepartos(rows = []) {
  const summary = {
    totalRepartos: rows.length, porEstado: {}, totalGuias: 0, entregadas: 0, retenidas: 0,
    noEntregadas: 0, pendientes: 0, efectividad: 0, crPendiente: 0,
  };
  for (const row of rows) {
    summary.porEstado[row.estado] = (summary.porEstado[row.estado] || 0) + 1;
    summary.totalGuias += toNum(row.total_guias);
    summary.entregadas += toNum(row.entregadas);
    summary.retenidas += toNum(row.retenidas);
    summary.noEntregadas += toNum(row.no_entregadas);
    summary.pendientes += pendientesDe(row);
    summary.crPendiente += toNum(row.contrarreembolso_pendiente);
  }
  summary.efectividad = efectividad(summary.entregadas, summary.totalGuias);
  return summary;
}
